export { toRequestQuery } from "../../../shared/api/transformers";

export function buildFormulaPayload({
  id,
  name,
  description,
  manufacturer_code,
  dc_id,
  dealer_type,
  category,
  coefficient_table,
  expression,
  expression_string,
  created_at,
}) {
  return {
    id,
    name,
    description,
    manufacturer_code,
    dc_id,
    dealer_type,
    category,
    coefficient_table,
    expression,
    expression_string,
    is_active: true,
    created_at: created_at || new Date().toISOString(),
    updated_at: new Date().toISOString(),
  };
}

export function buildCoefficientTablePayload({
  id,
  name,
  description,
  table_type,
  selected_fields,
  rows,
  created_at,
}) {
  return {
    id,
    name,
    description,
    table_type,
    selected_fields,
    rows,
    created_at: created_at || new Date().toISOString(),
    updated_at: new Date().toISOString(),
  };
}

export function expressionToString(expression = []) {
  return expression
    .map((item) => {
      if (item.type === "field") return item.value;
      return item.value.toString();
    })
    .join(" ");
}
